module.exports = __webpack_public_path__ + "static/media/editar.971ed983.svg";